<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <section>
        <div class="container">
          <div class="archaic-upgrade-container-fluid">
            <!-- BreadCrumb component starts here -->
            <nav class="mt-4" style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active" aria-current="page">
                  Ancestry
                </li>
                <li class="breadcrumb-item"><a href="#">Neanderthals</a></li>
              </ol>
            </nav>
            <!-- BreadCrumb Component ends here -->

            <!-- Heading Component starts here -->
            <div class="heading-row">
              <h1>Archaic Human Upgrade</h1>
            </div>
            <!-- Heading Component ends here -->

            <!-- 1st Box Component starts here -->
            <div class="archaic-upgrader-container">
              <div class="archaic-upgrader-wrapper">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="archaic-image-row">
                      <img :src="ArchaicUpgradeImage" alt="" />

                      <!-- 3 col 1 row starts here -->
                      <div class="image-gallery-row">
                        <div>
                          <img :src="Col1Image" alt="" />
                        </div>
                        <div>
                          <img :src="Col2Image" alt="" />
                        </div>
                        <div>
                          <img :src="Col3Image" alt="" />
                        </div>
                      </div>
                      <!-- 3 col 1 row ends here -->
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="archaic-content-purchase-row">
                      <h2>Archaic Upgrade</h2>
                      <p>$20.00</p>
                      <p>
                        Our Archaic DNA test allows you to explore in depth how
                        much of your DNA is attributed to Neanderthal and
                        Denisovan humans, You may even have inherited physical
                        traits them from many thousands of years ago.
                      </p>

                      <p>You will Receive:</p>
                      <ul>
                        <li>Scores for both Denisovan and Neanderthal</li>
                        <li>How your result compares to other people</li>
                        <li>
                          Traits - Your physical characteristics that have been
                          influenced by Archaic Human DNA
                        </li>
                      </ul>
                      <button>Purchase Now</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 1st Box Component ends here -->

            <!-- 2nd Box Component starts here -->
            <div class="description-wrapper">
              <h3>Description</h3>
              <p>
                With our in depth Archaic Human DNA analysis we allow you to see
                how much of your genome originated from two different Archaic
                Human subspecies: Neanderthals and Denisovans.
              </p>
              <p>
                You will also see how your Archaic DNA content compares to a
                wider group of people from our user base, as well as this you
                can compare your DNA to different human populations from around
                the world.
              </p>
              <p>
                Ever wondered how ancient your physical characteristics are? Did
                they benefit your ancestors to hunt, find food or a partner. We
                can show you which of your genetically influenced physical
                characteristics are derived from Archaic Human DNA.
              </p>

              <h4>FAQs</h4>
              <div class="FAQs-container">
                <div class="accordion" id="accordionExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        What does your Denisovan Score mean?
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        <p>
                          Your Denisovan score represents the number of alleles
                          (DNA letters) that you share with Denisovans. A total
                          of 817 human genome locations (SNPs) have been
                          identified as originating in Denisovans. By
                          multiplying this number by 2 we get the total number
                          of alleles that we calculate your Denisovan score
                          over: 1,634 Therefore, Denisovan scores range between
                          0 and 1,634. Typically, the maximum score you might
                          expect to see is 400.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Accordion Item #2
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        <strong>This is the second item's accordion body.</strong>
                        It is hidden by default, until the collapse plugin adds
                        the appropriate classes that we use to style each
                        element. These classes control the overall appearance,
                        as well as the showing and hiding via CSS transitions.
                        You can modify any of this with custom CSS or overriding
                        our default variables. It's also worth noting that just
                        about any HTML can go within the
                        <code>.accordion-body</code>, though the transition does
                        limit overflow.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Accordion Item #3
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        <strong>This is the third item's accordion body.</strong>
                        It is hidden by default, until the collapse plugin adds
                        the appropriate classes that we use to style each
                        element. These classes control the overall appearance,
                        as well as the showing and hiding via CSS transitions.
                        You can modify any of this with custom CSS or overriding
                        our default variables. It's also worth noting that just
                        about any HTML can go within the
                        <code>.accordion-body</code>, though the transition does
                        limit overflow.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 2nd Box Component ends here -->
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import "../../styles/pages/ArchaicUpgrade.scss";
import Header from "@/components/header/Header.vue";
import ArchaicUpgradeImage from "../../assets/images/Neatherland/archaicupgrade.jpeg";
import Col1Image from "../../assets/images/Neatherland/col1.jpeg";
import Col2Image from "../../assets/images/Neatherland/col2.jpeg";
import Col3Image from "../../assets/images/Neatherland/col3.jpeg";

export default {
  name: "ArchaicUpgrade",
  components: {
    Header,
  },
  data() {
    return {
      ArchaicUpgradeImage,
      Col1Image,
      Col2Image,
      Col3Image,
    };
  },
};
</script>